import { render, staticRenderFns } from "./InventoryList.vue?vue&type=template&id=e5453996&scoped=true&"
import script from "./InventoryList.vue?vue&type=script&lang=js&"
export * from "./InventoryList.vue?vue&type=script&lang=js&"
import style0 from "./InventoryList.vue?vue&type=style&index=0&id=e5453996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5453996",
  null
  
)

export default component.exports